import axios from 'axios'

const editEmployee = async (id, userData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updateSystemUser/${id}`,
      userData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default editEmployee
